(function () {
  function detectBusyAppPlatform() {
    const ua = navigator.userAgent || '';
    const platform = navigator.platform || '';
    const isIOS =
      /iPhone|iPod/i.test(ua) ||
      (platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    const isAndroid = /Android/i.test(ua);
    const isMac = !isIOS && (/Mac/i.test(platform) || /Macintosh/i.test(ua));

    if (isIOS) {
      return 'ios';
    }
    if (isAndroid) {
      return 'android';
    }
    if (isMac) {
      return 'macos';
    }
    return 'macos';
  }

  function applyHeroStoreLinks(group) {
    const primary = detectBusyAppPlatform();

    for (const link of group.querySelectorAll('[data-platform]')) {
      const isPrimary = link.dataset.platform === primary;
      const labelEl = link.querySelector('.platforms_button-label');

      link.classList.toggle('is-macos', isPrimary);
      link.classList.toggle('is-outline', !isPrimary);
      link.classList.toggle('is-icon-only', !isPrimary);

      if (labelEl) {
        labelEl.hidden = !isPrimary;
      }

      if (isPrimary) {
        link.removeAttribute('aria-label');
      } else {
        link.setAttribute('aria-label', link.dataset.ariaLabel || '');
      }
    }

    group.setAttribute('data-hero-store-ready', '');
  }

  function applyPlatformsStoreLinks(group) {
    const primary = detectBusyAppPlatform();

    group.dataset.primaryPlatform = primary;

    for (const link of group.querySelectorAll('a[data-platform]')) {
      const isPrimary = link.dataset.platform === primary;

      link.classList.toggle('is-macos', isPrimary);
      link.classList.toggle('is-outline', !isPrimary);
    }

    group.setAttribute('data-platforms-store-ready', '');
  }

  function initBusyAppPlatformLinks() {
    for (const group of document.querySelectorAll('[data-hero-store-links]')) {
      applyHeroStoreLinks(group);
    }

    for (const group of document.querySelectorAll('[data-platforms-store-links]')) {
      applyPlatformsStoreLinks(group);
    }
  }

  function initPlatformsOnViewportChange() {
    const mobileQuery = window.matchMedia('(max-width: 766px)');
    mobileQuery.addEventListener('change', () => {
      for (const group of document.querySelectorAll('[data-platforms-store-links]')) {
        applyPlatformsStoreLinks(group);
      }
    });
  }

  initBusyAppPlatformLinks();
  initPlatformsOnViewportChange();
  document.addEventListener('DOMContentLoaded', initBusyAppPlatformLinks);
  document.addEventListener('shopify:section:load', initBusyAppPlatformLinks);
})();
